import React from 'react';
import PropTypes from 'prop-types';
import { uuidv4 } from '../../../../utils/uuid';

import './styles.css';

class Table extends React.Component {
  render() {
    const {
      states,
      total,
      header,
    } = this.props;

    return (
      <table className="OperationalDashboard__Table">
        <thead>
          <tr>
            {header &&
              header.map(col => (
                <td key={uuidv4()}>{col}</td>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {states && states.map(state => (
            <tr key={uuidv4()}>
              <td>{state.initials} - {state.state}</td>
              <td className="white">{state.inSeparation.tons} Ton / {state.inSeparation.nfs} NFs</td>
              <td className="white">{state.separated.tons} Ton / {state.separated.nfs} NFs</td>
            </tr>
          ))}
          {total &&
            <tr className="OperationalDashboard__Table__Total">
              <td>Todo o Brasil</td>
              <td className="OperationalDashboard__Table__Total__InSeparation">{total.inSeparation.tons} Ton / {total.inSeparation.nfs} NFs</td>
              <td className="OperationalDashboard__Table__Total__Separated">{total.separated.tons} Ton / {total.separated.nfs} NFs</td>
            </tr>
          }
        </tbody>
      </table>
    );
  }
}

Table.propTypes = {
  states: PropTypes.arrayOf(PropTypes.object).isRequired,
  total: PropTypes.objectOf(PropTypes.object).isRequired,
  header: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Table;
